import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
export var HtmlViewer = function (_a) {
    var filePath = _a.filePath, storageType = _a.storageType;
    var _b = useState(null), fetchedData = _b[0], setFetchedData = _b[1];
    useEffect(function () {
        if (storageType === 1) {
            fetch(filePath)
                .then(function (x) { return x.text(); })
                .then(function (x) { return setFetchedData(x); });
        }
    }, [filePath, storageType]);
    if (storageType === 1) {
        return (_jsx("iframe", { title: "HTML Preview", sandbox: "", style: { border: 'none', width: '100%', height: '100%' }, srcDoc: fetchedData }));
    }
    return (_jsx("iframe", { title: "HTML Preview", sandbox: "", style: { border: 'none', width: '100%', height: '100%' }, src: filePath }));
};
export default HtmlViewer;
